export const lookupTableES = {
  'Add Row': 'Add Row',
  'Delete Row': 'Delete Row',
  Export: 'Export',
  Import: 'Import',
  'Text (Tab Delimited)': 'Text (Tab Delimited)',
  'Text (Comma Delimited)': 'Text (Comma Delimited)',
  'Text (Other)': 'Text (Other)',
  'Excel (xls)': 'Excel (xls)',
  'Excel (xlsx)': 'Excel (xlsx)',
  'Include Column Headings': 'Include Column Headings',
  Exporting: 'Exporting',
  Options: 'Options',
  Delimiter: 'Delimiter',
  Settings: 'Settings',
  'Export Data': 'Export Data',
  'Comma Delimited': 'Comma Delimited',
  'Tab Delimited': 'Tab Delimited',
  'Other (specify delimiter)': 'Other (specify delimiter)',
  'Ignore column headings': 'Ignore column headings',
  'Allow import to add additional rows': 'Allow import to add additional rows',
  'Import Lookup Data': 'Import Lookup Data',
  'Data Import Definition': 'Data Import Definition',
  'Number of matched columns': 'Number of matched columns',
  'Import Warnings': 'Import Warnings',
  'Import Progress': 'Import Progress',
  'Importing individual data...': 'Importing individual data...',
  'Import more': 'Import more',
  'Failed to create row': 'Failed to create row',
  Warning: 'Warning',
  'This column cannot have an empty field': 'This column cannot have an empty field',
  'Failed to create field': 'Failed to create field',
  'Failed to update row': 'Failed to update row',
  Open: 'Open',
  'Enter the cell value to add a row': 'Enter the cell value to add a row',
  'Failed to export data': 'Failed to export data',
};